/* eslint-disable one-var,no-bitwise,prefer-destructuring */
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Can, {checkPermission} from './guards/can';

const colorClasses = {
  red: 'red-btn',
  yellow: 'yellow-btn',
  grey: 'grey-btn',
  white: 'white-btn'
};

const ArrowButton = ({
  color = 'red',
  ghost = true,
  submit = true,
  arrow = {},
  className,
  block = false,
  permissions,
  children,
  ...props
}) => {
  let buttonType = colorClasses[color];
  if (ghost) {
    buttonType = buttonType.split('-');
    buttonType.splice(1, 0, 'ghost');
    buttonType = buttonType.join('-');
  }
  let action = true,
    subjectClass = '',
    hasPermission = true;
  if (permissions) {
    action = permissions.action;
    subjectClass = permissions.subjectClass;
    hasPermission = checkPermission(action, subjectClass);
  }

  if (props.disabled) {
    hasPermission &= !props.disabled;
  }

  return (
    <Can action={!permissions || permissions.mode !== 'hide' || hasPermission} subjectClass={subjectClass}>
      <Button
        className={classnames(buttonType, className, {'btn-block': block})}
        type={submit ? 'submit' : 'button'}
        {...props}
        disabled={!hasPermission && (!permissions || !permissions.mode || permissions.mode === 'disable')}
      >
        {arrow && arrow.direction === 'left' && <span className="ignite-icon arrow-left"/>}
        {children}
        {arrow && arrow.direction !== 'left' && <span className="ignite-icon arrow-right"/>}
      </Button>
    </Can>
  );
};

ArrowButton.propTypes = {
  color: PropTypes.oneOf([
    'red', 'yellow', 'grey', 'white'
  ]),
  ghost: PropTypes.bool,
  submit: PropTypes.bool,
  arrow: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object
  ]),
  block: PropTypes.bool,
  className: PropTypes.any,
  permissions: PropTypes.shape({
    action: PropTypes.string,
    subjectClass: PropTypes.string,
    mode: PropTypes.oneOf(['hide', 'disable']),
  })
};

export default ArrowButton;
